import { getRem } from './../../core';
import { INPUT_SIZES } from './../../input';

export const searchInputBorderRadius = {
  [INPUT_SIZES.LARGE]: getRem('20px'),
  [INPUT_SIZES.SMALL]: getRem('16px'),
  [INPUT_SIZES.STANDARD]: getRem('18px'),
};
